<iframe width="100%" style="height: 100%;" [src]="srcUrl" *ngIf="appConfig.settings.Dashboard.Enable && isDashboardAlreadyOpened"></iframe>